<template>
  <div>
    <div
      id="gallery-audios"
      class="thumbnail-box-conatiner mt-20 position-relative">
      <input
        ref="input"
        v-model="searchQuery"
        type="search"
        placeholder="Search"
        class="bm-input py-6 pe-32 ps-32 fs-14 rounded rounded-4 w-100"
        @input="checkQueryValue"
        @keydown.enter.stop="changeQueryValue">
      <div
        :class="[isFocusedOut ? 'active-search':'']"
        class="search-icon position-absolute">
        <icon name="search"/>
      </div>
      <div
        :class="[searchQuery !='' ? 'd-block': 'd-none']"
        class="close-icon position-absolute"
        @click="clearValue($event)">
        <icon
          name="close-icon"
        />
      </div>
      <div
        v-masonry
        id="audioGalleryMasonry"
        class="image-container"
        transition-duration="0"
        item-selector=".image-wrapper"
        gutter="10">
        <Spinner
          v-show="loader"
          :speed="1"
          size="huge"
          message="Loading..."
          class="position-absolute inner-Loader"/>

        <div
          v-for="(audio, index) in getFilteredAudios"
          :key="index"
        >
          <div
            v-masonry-tile
            v-if="audio"
            class="image-wrapper">
            <div
              class="image-item thumbnail-border cursor-pointer"
              @click="insertAudioToCanvas(audio)">
              <div
                class="image-delete-button"
                @click.stop="deleteAudioFromMyGallery(audio.VirtualPath)">
                <icon name = "trash"/>
              </div>
              <img
                src="@/assets/images/mp3-file.png"
                style="width: 30%">
              <div class="audio--name">
                {{ audio.Name }}
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:       'StockAudioBox',
  components: { Spinner },
  data() {
    return {
    /* audios: [{
        Id: "b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        Name: "Ed_Sheeran_-_Perfect5.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect5.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
      },
    {
      Id: "b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
          Name: "Ed_Sheeran_-_Perfect5.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect5.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect5.mp3#b0161ac9-e2b4-453d-b9ce-46f603b9f4dc",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "3038eacc-57a8-41dd-9199-d23e4711b087",
          Name: "Ed_Sheeran_-_Perfect4.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect4.mp3#3038eacc-57a8-41dd-9199-d23e4711b087",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect4.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect4.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect4.mp3#3038eacc-57a8-41dd-9199-d23e4711b087",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "b4e75dcd-e516-4ead-b755-f3c8504fd43b",
          Name: "Ed_Sheeran_-_Perfect3.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect3.mp3#b4e75dcd-e516-4ead-b755-f3c8504fd43b",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect3.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect3.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect3.mp3#b4e75dcd-e516-4ead-b755-f3c8504fd43b",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: 0,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "ac9b537c-d0a0-4999-9d0e-2837f2987b93",
          Name: "Ed_Sheeran_-_Perfect2.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect2.mp3#ac9b537c-d0a0-4999-9d0e-2837f2987b93",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect2.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-Ed_Sheeran_-_Perfect2.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/Ed_Sheeran_-_Perfect2.mp3#ac9b537c-d0a0-4999-9d0e-2837f2987b93",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: -1,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "0f9a80cc-d100-4708-aca8-3c344bd34fe4",
          Name: "sample-6s8.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-6s8.mp3#0f9a80cc-d100-4708-aca8-3c344bd34fe4",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-6s8.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-sample-6s8.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-6s8.mp3#0f9a80cc-d100-4708-aca8-3c344bd34fe4",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: -1,
        HighResV2Height: 0,
        Description: null
    },
    {
      Id: "3e9d2741-a9f7-4783-b5a2-32a661c33dcd",
          Name: "sample-3s.mp3",
        DefaultImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-3s.mp3#3e9d2741-a9f7-4783-b5a2-32a661c33dcd",
        HighResImageUrl: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-3s.mp3",
        ImageType: 11,
        CropOption: 0,
        ImageThumbnailPath: "https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-sample-3s.mp3",
        ImageThumbnailPathV2: "https://www.bankmarketingcenter.com/temp/uploadedimages/sample-3s.mp3#3e9d2741-a9f7-4783-b5a2-32a661c33dcd",
        ImageThumbnailPathV2Width: 0,
        ImageThumbnailPathV2Height: 0,
        HighResV2Width: -1,
        HighResV2Height: 0,
        Description: null
    }], */
      isLoading:       false,
      audios:          [],
      loader:          false,
      searchQuery:     '',
      searchAudios:    [],
      isFocused:       false,
      isFocusedOut:    false,
      isAudioSearch:   false,
      myGalleryAudios:
          {
            MaxLimit:     20,
            LowLimit:     0,
            isProcessing: false,
          },
    };
  },
  computed: {
    getFilteredAudios() {
      if (this.searchQuery && this.isAudioSearch) {
        return this.searchAudios;
      }
      return this.audios;
    },
  },
  mounted() {
    setTimeout(() => {
      this.fetchUserAudios();
      this.bindScrollToGalleryAudios();
    }, 0);
  },
  methods: {
    checkQueryValue() {
      if (!this.searchQuery.length) {
        this.isAudioSearch = false;
        this.searchAudios  = [];
      }
    },
    clearValue() {
      this.searchQuery       = '';
      this.searchAudios      = [];
      this.isAudioSearch     = false;
      this.isFocused         = false;
      this.$refs.input.value = '';
    },

    typeFocus() {
      if (this.searchQuery.length > 0) {
        this.isFocused = true;
      } else {
        this.isFocused = false;
      }
    },

    removeFocus() {
      this.isFocused = false;
    },

    focusIn() {
      this.isFocusedOut = true;
    },
    fetchMyGalleryAudiosWithKeyword() {
      this.makeLoaderVisible();
      this.myGalleryAudios.isProcessing = true;
      const urlSearchPart               = window.location.search;
      const newUrlSearchParams          = new URLSearchParams(urlSearchPart);

      const userId    = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://${domainUrl}.com/&userId=${userId}&keyword=${this.searchQuery}`;
      /* const url = `https://dev2.wysiwyg.bankmarketingcenter.com/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://www.bankmarketingcenter.com/&userId=21d29854-fb88-45e6-9a12-b1f4e6c67d45&maximumRows=20&startRowIndex=0&keyword=${this.searchQuery}` */
      const oReq = new XMLHttpRequest();
      oReq.addEventListener('load', this.getMyGalleryAudiosWidthKeyword);
      oReq.addEventListener('error', (e) => {
        console.log(e);
        this.MyGalleryAudios.isProcessing = false;
        this.makeLoaderInVisible();
        console.error(e);
      });
      oReq.open('GET', url);
      oReq.send();
    },
    changeQueryValue(event) {
      this.searchQuery = event.target.value;
      if (this.searchQuery.length) {
        this.isAudioSearch = true;
        this.fetchMyGalleryAudiosWithKeyword();
      }
    },
    deleteAudioFromMyGallery(id) {
      console.log('id', id);
      /* EventBus.$emit('ondeleteImageFromMyGallary', id);
      const indexToDelete = this.audios.findIndex((audio) => audio.Id === id);

      if (indexToDelete !== -1) {
        this.audios.splice(indexToDelete, 1);
        console.log(`Audio with Id ${id} deleted successfully.`);
      } */
    },
    bindScrollToGalleryAudios() {
      const galleryAudios = document.getElementById('gallery-audios');
      if (!galleryAudios) { return; }
      galleryAudios.onscroll = null;
      galleryAudios.addEventListener('scroll', () => {
        if (!this.myGalleryAudios.isProcessing && Math.round(galleryAudios.scrollTop + galleryAudios.clientHeight) >= galleryAudios.scrollHeight - 10) {
          this.makeLoaderVisible();
          this.fetchUserAudios();
        }
      });
    },
    insertAudioToCanvas(audioObj) {
      const self = this;
      this.makeLoaderVisible();
      if (audioObj) {
        const objectURL       = audioObj.VirtualPath;
        const audioPlayer     = document.createElement('audio');
        audioPlayer.src       = objectURL;
        let durationInSeconds = null;
        audioPlayer.addEventListener('loadedmetadata', () => {
          durationInSeconds     = audioPlayer.duration;
          audioObj.audioUrl     = objectURL;
          audioObj.duration     = durationInSeconds;
          audioObj.startTime    = 0;
          audioObj.endTime      = audioObj.duration;
          audioObj.fadeIn       = 0;
          audioObj.fadeOut      = audioObj.duration;
          audioObj.trimDuration = audioObj.duration;
          EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, audioObj);
          EventBus.$emit('toggleAudioLeftSectionAccordion', true);
          EventBus.$emit('selectAudioLayerFromLeftSection', true);
          self.$store.commit('setDisplayAddAudioModal', false);
          this.makeLoaderInVisible();
        });
        audioPlayer.remove();
      }
    },

    fetchUserAudios() {
      if (this.myGalleryAudios.MaxLimit != this.myGalleryAudios.LowLimit) {
        this.makeLoaderVisible();
        this.myGalleryAudios.isProcessing = true;
        const urlSearchPart               = window.location.search;
        const newUrlSearchParams          = new URLSearchParams(urlSearchPart);

        const bankId = newUrlSearchParams.has('bankId') ? newUrlSearchParams.get('bankId') : 'fde5ed9d-816f-43fd-89f3-97a542947193';
        const userId = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';

        const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
        const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://${domainUrl}.com/&userId=${userId}&maximumRows=${this.myGalleryAudios.MaxLimit}&startRowIndex=${this.myGalleryAudios.LowLimit}&keyword=audio`;
        /* const url = `https://dev2.wysiwyg.bankmarketingcenter.com/web_service.aspx?method=SearchUploadedAudiosByUser&domainURL=https://www.bankmarketingcenter.com/&userId=21d29854-fb88-45e6-9a12-b1f4e6c67d45&maximumRows=20&startRowIndex=0&keyword=audio` */
        console.log(url);

        const oReq = new XMLHttpRequest();
        oReq.addEventListener('load', this.loadMyGalleryAudio);
        oReq.addEventListener('error', (e) => {
          console.log(e);
          this.MyGalleryAudios              = [0];
          this.MyGalleryAudios.isProcessing = false;
          this.makeLoaderInVisible();
          console.error(e);
        });
        oReq.open('GET', url);
        oReq.send();
      }
    },
    makeLoaderVisible() {
      this.loader = true;
    },
    makeLoaderInVisible() {
      this.loader = false;
    },
    loadMyGalleryAudio(data) {
      console.log(data);
      try {
        const parser         = new DOMParser();
        const xmlParsed      = parser.parseFromString(data.target.response, 'text/xml');
        let audiosCollection = xmlParsed.getElementsByTagName('SearchUploadedAudiosByUserResult');
        audiosCollection     = JSON.parse(audiosCollection[0].innerHTML);
        if (this.myGalleryAudios.MaxLimit < audiosCollection.Count) {
          this.myGalleryAudios.LowLimit  = this.myGalleryAudios.MaxLimit;
          this.myGalleryAudios.MaxLimit += 20;
        } else {
          this.myGalleryAudios.MaxLimit = audiosCollection.Count;
        }
        if (this.myGalleryAudios.LowLimit != parseInt(audiosCollection.Count)) {
          this.audios = [...this.audios, ...audiosCollection.Items];
        } else { // condition for checking the all total number of the image is called and there is no more api call needed
          this.myGalleryAudios.LowLimit = 0;
          this.myGalleryAudios.MaxLimit = 0;
        }
      } catch (e) {
        this.audios = [0];
        console.log('Error:loadMyGalleryImages/parseFromXml', e.message);
      } finally {
        this.myGalleryAudios.isProcessing = false;
        this.makeLoaderInVisible();
      }
    },
    getMyGalleryAudiosWidthKeyword(data) {
      try {
        const parser         = new DOMParser();
        const xmlParsed      = parser.parseFromString(data.target.response, 'text/xml');
        let audiosCollection = xmlParsed.getElementsByTagName('SearchUploadedAudiosByUserResult');
        audiosCollection     = JSON.parse(audiosCollection[0].innerHTML);
        this.searchAudios    = audiosCollection.Items;
      } catch (e) {
        console.log('Error:loadMyGalleryImages/parseFromXml', e.message);
      } finally {
        this.myGalleryAudios.isProcessing = false;
        this.makeLoaderInVisible();
      }
    },
  },
};
</script>

<style scoped lang="scss">

.thumbnail-box-conatiner {
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding: 0px 20px;

  .image-container {
    /*column-width: 14vw;
    grid-auto-flow: dense;*/
    margin-top: 10px;
    min-height: 412px;

    .image-wrapper {
      width: calc(25% - 10px);
      margin-bottom: 20px;
    }

    .image-item {
      display: flex;
      justify-content: center;
      align-items: center;
      vertical-align: middle;
      transition: all 0.2s;
      cursor: pointer;
      position: relative;
      margin-bottom: 10px;
      float: left;
      &:hover {
        box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.2);
        padding: 5px;
        border-radius: 4px;
        opacity: 1;
      }

      &:hover {
        .image-delete-button {
          opacity: 1 !important;
        }
      }

      .image-delete-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 3px;
        opacity: 0;
        height: 24px;
        width: 24px;
      }

      audio, img, {
        width: 100%;
        margin-bottom: 0;
        border-radius: 10px !important;
        float: left;
      }

      .thumbnail-border {
        border: 2px solid #3bb0fa !important
      }
    }


  }

  .inner-Loader {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 56;
    top: 113px;
    bottom: 2vh;

    .vue-simple-spinner-text {
      color: #52A7E1 !important
    }
  }
}
.cursor-pointer{
  cursor: pointer;
}
.search-icon {
  left: 30px;
  top: 11px;
}

.close-icon {
  right: 30px;
  top: 10px;
}
.btn-close {
  height: 16px;
  width: 16px;
  outline: 0px;

  &:focus {
    outline: 0px;
  }
}
.focused {
   .bm-input {
     border-color: $blue50 !important;
     color: $grey80;
   }

   .close-icon {
     display: block !important;
   }

   .search-icon {
     svg {
       path {
         stroke: #3BB0FA;
       }
     }
   }
 }
.audio--name{
  width: 70%;
  display: flex;
}
</style>
